import { useMemo } from 'react';
export const useUserAndTeamOptionIds = ({
  teamOptions,
  userOptions
}) => useMemo(() => {
  const teamIds = teamOptions === null || teamOptions === void 0 ? void 0 : teamOptions.map(({
    value
  }) => value);
  const userIds = userOptions === null || userOptions === void 0 ? void 0 : userOptions.map(({
    value
  }) => value);
  return {
    teams: teamIds || [],
    users: userIds || []
  };
}, [teamOptions, userOptions]);